import styled from "styled-components";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import { safeAreaTopPaddingPlus } from "../../../styles/safeArea";

export const GuidesSubHeader = styled.div`
  width: 100%;
  background-color: ${(props) => props.backgroundColor || colors.coral};
  /* The safe-area inset folds into the top padding so the coloured
   * band bleeds up under the notch on standalone (Capacitor / PWA).
   * Inert on regular browsers where env() is 0. */
  ${safeAreaTopPaddingPlus(40)}
  ${breakpoints.mdUp} {
    z-index: 500;
  }
  min-height: 350px;
  ${breakpoints.smDown} {
    min-height: 0px;
  }
`;

export const GuidesTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 310px;
  ${breakpoints.smDown} {
    min-height: 0px;
  }
`;

export const GuidesHeaderTitle = styled.p`
  white-space: pre-wrap;
  font-size: 75px;
  line-height: 0.9em;
  letter-spacing: -0.025em;
  -webkit-letter-spacing: -0.025em;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 0px !important;
  ${breakpoints.mdDown} {
    font-size: 52px;
  }
  ${breakpoints.smDown} {
    font-size: 42px;
  }
  word-break: break-word;
  padding: 0px 20px 40px 0px;
`;

export const GuidesHeaderDescription = styled.p`
  white-space: pre-wrap;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.black};
  font-family: ${fonts.fontBauRegular};
  word-break: break-word;
  padding: 0px 20px 40px 0px;
`;

export const HeaderImageContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  ${breakpoints.smDown} {
    align-items: flex-end;
  }
`;

export const HeaderImageInnerContainer = styled.div`
  width: 100%;
  min-height: 200px;
  max-height: 400px;
  ${breakpoints.mdDown} {
    min-height: 150px;
    max-height: 250px;
  }
  display: flex;
  ${breakpoints.smDown} {
    width: 50%;
    min-height: 0px;
    padding-bottom: 20px;
  }
  ${breakpoints.xsDown} {
    width: 60%;
  }
  overflow: hidden;
`;

export const HeaderImage = styled.img`
  display: block;
  position: relative;
  right: 0;
  bottom: 0px;
  height: 100%;
  width: 100%;
  max-height: 400px;
`;
